import React, { useState, useEffect } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Slide from '@mui/material/Slide';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import ApiClient from '../../../config/api';
import InputOtp from '../../../components/otpInput';
import VerifyIdentification from './verifyIdentification';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const statusButtonSx = {
  margin: '0px !important',
  minHeight: 58,
  py: 1.75,
  fontSize: '18px',
  fontWeight: 700,
  borderRadius: '12px',
};

const ChangeStatusConfirm = ({
  open,
  setOpen,
  setOpenGetParcel,
  selectedParcel,
  setOpenRejectedModal,
  selectedTask,
  setSelectedStatus,
}) => {
  const api = ApiClient();
  const [statusData, setStatusData] = useState([]);
  const [statusDataLeaf, setStatusDataLeaf] = useState([]);
  const [approvePod, setApprovePod] = useState(false);
  const [openPodModal, setOpenPodModal] = useState(false);
  const [podValue, setPodValue] = useState('');
  const [pendingOtpStatus, setPendingOtpStatus] = useState(null);
  const [showVerifyMethods, setShowVerifyMethods] = useState(false);
  const [openIdentityModal, setOpenIdentityModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const getInlineStatuses = (...sources) =>
    sources
      .flatMap((source) => [
        source?.statusOptions,
        source?.statuses,
        source?.validStatuses,
        source?.validStatus,
        source?.availableStatuses,
        source?.cycleStatuses,
        source?.cycleStatus,
        source?.statusData,
      ])
      .find((statusList) => Array.isArray(statusList) && statusList.length) ||
    [];

  useEffect(() => {
    setStatusDataLeaf([]);
    setShowVerifyMethods(false);
    setOpenIdentityModal(false);
    setOpenPodModal(false);
    setPendingOtpStatus(null);
    setPodValue('');
    setError('');

    if (open == 'parcel' && selectedParcel) {
      setStatusData(getInlineStatuses(selectedParcel, selectedParcel?.parcel));
    } else if ((open == 'task' || open?.type === 'group') && selectedTask) {
      setStatusData(getInlineStatuses(selectedTask, selectedTask?.details));
    } else {
      setStatusData([]);
    }
  }, [open, selectedParcel, selectedTask]);

  const handleCancel = () => {
    setOpen(false);
  };

  const handleCancelPodModal = () => {
    setOpenPodModal(false);
    setPodValue('');
    setError('');
    setShowVerifyMethods(Boolean(pendingOtpStatus));
  };

  const handleCancelIdentityModal = () => {
    setOpenIdentityModal(false);
    setShowVerifyMethods(Boolean(pendingOtpStatus));
  };

  const getActivityId = () => selectedParcel?.id || selectedTask?.id;

  const openStatusAction = (item) => {
    if (!item?.isFinalLeaf) {
      setStatusDataLeaf(item?.leafs || []);
      return;
    }

    if (item?.setDataIsRequired) {
      setOpenRejectedModal(open);
      setOpen(false);
      return;
    }

    setOpenGetParcel(open);
    setOpen(false);
  };

  const handleChange = (item) => {
    setSelectedStatus(item);

    if (item?.setOtpRequired) {
      setPendingOtpStatus(item);
      setShowVerifyMethods(true);
      return;
    }

    openStatusAction(item);
  };

  const handleSelectOtpMethod = () => {
    setShowVerifyMethods(false);
    setOpenPodModal(true);
  };

  const handleSelectIdentityMethod = () => {
    setShowVerifyMethods(false);
    setOpenIdentityModal(true);
  };

  const completeVerifiedDelivery = () => {
    setOpenPodModal(false);
    setOpenIdentityModal(false);
    setShowVerifyMethods(false);
    setPodValue('');
    setApprovePod(getActivityId());
    openStatusAction(pendingOtpStatus);
    setPendingOtpStatus(null);
  };

  const handleChangePod = async (otpCode) => {
    setPodValue(otpCode);
    setError('');

    if (!otpCode || otpCode.length < 5) {
      return;
    }

    if (otpCode?.length === 5) {
      try {
        setIsLoading(true);
        setError('');
        const response = await api.post('/api/app/v1/shipito/tasks/set-otp', {
          activityId: getActivityId(),
          code: otpCode,
        });
        completeVerifiedDelivery();
      } catch (error) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          setError(error.response.data.message);
        }
      }
      setIsLoading(false);
    } else {
      setError('لطفا رمز پیامک شده را وارد نمایید');
      setIsLoading(false);
    }
  };

  const handleResendPod = async () => {
    try {
      setIsLoading(true);
      setError('');
      await api.post('/api/app/v1/shipito/tasks/pod/resend', {
        activityId: getActivityId(),
      });
      setPodValue('');
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message);
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Dialog
        style={{ zIndex: 99998 }}
        TransitionComponent={Transition}
        keepMounted
        PaperComponent={(props) => (
          <Paper
            style={{
              position: 'absolute',
              bottom: 0,
              margin: '0px',
              width: '100%',
              maxWidth: 'unset',
              minHeight: '62dvh',
              maxHeight: '88dvh',
              direction: 'rtl',
              borderRadius: '24px 24px 0px 0px',
              display: 'flex',
              flexDirection: 'column',
            }}
            {...props}
          />
        )}
        onClose={handleCancel}
        open={Boolean(open)}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: '0px',
            mb: '16px',
          }}
        >
          <Typography
            sx={{
              fontSize: '19px',
              color: 'text.primary',
            }}
          >
            {showVerifyMethods ? 'تایید تحویل' : open?.label || 'تغییر وضعیت'}
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleCancel}
            sx={{ color: '#71717A', padding: 0 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogActions
          sx={{
            direction: 'rtl',
            p: '0px 24px 24px 24px',
            alignItems: 'flex-start',
            flex: 1,
          }}
        >
          {showVerifyMethods ? (
            <Grid container spacing={2} display={'flex'} flexDirection="column">
              <Grid item sx={{ flexGrow: 1, minWidth: 150 }}>
                <Button
                  size="large"
                  onClick={handleSelectOtpMethod}
                  color="primary"
                  variant="contained"
                  fullWidth
                  sx={statusButtonSx}
                >
                  کد تحویل
                </Button>
              </Grid>
              <Grid item sx={{ flexGrow: 1, minWidth: 150 }}>
                <Button
                  size="large"
                  onClick={handleSelectIdentityMethod}
                  color="primary"
                  variant="contained"
                  fullWidth
                  sx={statusButtonSx}
                >
                  احراز هویت
                </Button>
              </Grid>
              <Grid item sx={{ flexGrow: 1, minWidth: 150 }}>
                <Button
                  size="large"
                  onClick={() => setShowVerifyMethods(false)}
                  color="primary"
                  variant="outlined"
                  fullWidth
                  sx={statusButtonSx}
                >
                  بازگشت
                </Button>
              </Grid>
            </Grid>
          ) : statusDataLeaf?.length == 0 ? (
            <Grid container spacing={2} display={'flex'} flexDirection="column">
              {statusData?.map((item) => (
                <Grid item key={item?.id} sx={{ flexGrow: 1, minWidth: 150 }}>
                  <Button
                    size="large"
                    onClick={() => handleChange(item)}
                    color="primary"
                    variant="contained"
                    fullWidth
                    sx={statusButtonSx}
                  >
                    {item?.title}
                  </Button>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Grid container spacing={2} display={'flex'} flexDirection="column">
              {statusDataLeaf?.map((item) => (
                <Grid item key={item?.id} sx={{ flexGrow: 1, minWidth: 150 }}>
                  <Button
                    size="large"
                    onClick={() => handleChange(item)}
                    color="primary"
                    variant="outlined"
                    fullWidth
                    sx={statusButtonSx}
                  >
                    {item?.title}
                  </Button>
                </Grid>
              ))}{' '}
              <Grid item sx={{ flexGrow: 1, minWidth: 150 }}>
                <Button
                  size="large"
                  onClick={() => setStatusDataLeaf([])}
                  color="primary"
                  variant="outlined"
                  fullWidth
                  sx={statusButtonSx}
                >
                  بازگشت
                </Button>
              </Grid>
            </Grid>
          )}
        </DialogActions>
      </Dialog>
      <Dialog
        style={{ zIndex: 99998 }}
        TransitionComponent={Transition}
        keepMounted
        PaperComponent={(props) => (
          <Paper
            style={{
              position: 'absolute',
              bottom: 0,
              margin: '0px',
              width: '100%',
              maxWidth: 'unset',
              minHeight: '62dvh',
              maxHeight: '88dvh',
              direction: 'rtl',
              borderRadius: '24px 24px 0px 0px',
              display: 'flex',
              flexDirection: 'column',
            }}
            {...props}
          />
        )}
        onClose={handleCancelPodModal}
        open={Boolean(openPodModal)}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            paddingBottom: '0px',
            mb: '16px',
          }}
        >
          <Typography
            sx={{
              fontSize: '19px',
              color: 'text.primary',
            }}
          >
            کد تحویل
          </Typography>
          <IconButton
            aria-label="close"
            onClick={handleCancelPodModal}
            sx={{ color: '#71717A', padding: 0 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogActions sx={{ direction: 'rtl', p: '0px 24px 16px 24px' }}>
          <Grid container spacing={2} display={'flex'} flexDirection="column">
            <Grid
              item
              sx={{
                flexGrow: 1,
                minWidth: 150,
                display: 'flex',
                justifyContent: 'center',
                mb: 8,
              }}
            >
              <InputOtp
                key={openPodModal ? 'pod-open' : 'pod-closed'}
                inputWrapperClass={'styles_otpInputWrapper'}
                disabled={isLoading}
                otpLength={5}
                onChange={handleChangePod}
                value={podValue}
                autocomplete="one-time-code"
              />
            </Grid>
            {error ? (
              <Grid item sx={{ flexGrow: 1, minWidth: 150 }}>
                <Typography color="error" textAlign="center" fontSize={13}>
                  {error}
                </Typography>
              </Grid>
            ) : null}
            <Grid item sx={{ flexGrow: 1, minWidth: 150 }}>
              <Button
                size="large"
                disabled={isLoading}
                onClick={handleResendPod}
                color="primary"
                variant="outlined"
                fullWidth
                sx={statusButtonSx}
              >
                ارسال مجدد کد
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
      <VerifyIdentification
        open={openIdentityModal}
        onClose={handleCancelIdentityModal}
        onSuccess={completeVerifiedDelivery}
        activityId={getActivityId()}
      />
    </>
  );
};

export default ChangeStatusConfirm;
